const appRoutes = {
  home: "/",
  addEntry: "/add-entry",
  numbers: "/numbers",
} as const;

export default appRoutes;
